<template>
    <div>
        <div>
            <el-form inline ref="queryForm" :model="queryForm" class="query-form">
                <el-form-item>
                    <el-cascader
                            clearable
                            :props="{
                                label:'name',
                                value:'id',
                                children:'subService',
                                disabled:'selected'
                            }"
                            placeholder="Service Types"
                            :options="services"
                            v-model="serviceIds"></el-cascader>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" circle @click="loadData"></el-button>
            </el-form>
        </div>

        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                stripe
                class="data-table"
                @row-click="openEdit"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'serviceName',label:'Service Name'},
                        {prop:'itemName',label:'Item Name'},
                        {prop:'min',label:'Min'},
                        {prop:'max',label:'Max'},
                        {prop:'status',label:'Status'},
                        {prop:'updated',label:'Updated Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="page.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="700px">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
                <el-form-item label="Service Name" prop="serviceIds">
                    <el-cascader
                            clearable
                            :props="{
                                label:'name',
                                value:'id',
                                children:'subService',
                                disabled:'selected'

                            }"
                            placeholder="Select service"
                            :options="services"
                            v-model="form.serviceIds"></el-cascader>
                </el-form-item>

                <el-form-item label="Item Name" prop="itemName">
                    <el-input v-model="form.itemName"></el-input>
                </el-form-item>

                <el-form-item label="Max" prop="max">
                    <el-input-number v-model="form.max" :min="0" :max="10000"
                                     label="label"></el-input-number>
                </el-form-item>

                <el-form-item label="Min" prop="min">
                    <el-input-number v-model="form.min" :min="0" :max="10000"
                                     label="label"></el-input-number>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                 <el-button @click="dialogVisible = false">Cancel</el-button>
                 <el-button type="primary" @click="saveData">Save</el-button>
             </span>
        </el-dialog>
    </div>
</template>

<script>
    import {priceList, priceCreate, priceUpdate, vendorServiceList} from '@/api/VendorAPI'
    import {mapGetters} from "vuex";

    export default {
        name: "VendorPriceList",
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                loading: false,
                form: {},
                queryForm: {},
                services: [],
                serviceIds: [],
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    serviceIds: [
                        {required: true, message: 'Please select one service'}
                    ],
                    itemName: [
                        {required: true, message: 'Please input the name for this item'}
                    ],
                    max: [
                        {required: true, message: 'Please input the max price for this item'}
                    ],
                    min: [
                        {required: true, message: 'Please input the min price for this item'}
                    ]
                }
            }
        },
        computed: mapGetters({
            companyId: "getCompanyId"
        }),
        methods: {
            loadData() {
                this.queryForm.serviceId = null
                if (this.serviceIds.length === 2) {
                    this.queryForm.serviceId = this.serviceIds[1]
                }
                this.$pageUtils(this, priceList);
            },
            openCreate() {
                this.form = {
                    serviceIds: []
                }
                this.dialogVisible = true
            },
            openEdit(row) {
                this.form = this.$copy(row)
                const mainServiceId = this.getMainServiceId(this.form.serviceId)
                this.form.serviceIds = [mainServiceId, this.form.serviceId]
                this.dialogVisible = true
            },
            getMainServiceId(serviceId) {
                const serviceList = this.services
                for (let mService of  serviceList) {
                    if (!mService.subService) {
                        return mService.id
                    }
                    for (let service of mService.subService) {
                        if (service.id === serviceId) {
                            return mService.id
                        }
                    }
                }
            },
            saveData() {
                const action = this.form.id ? priceUpdate : priceCreate;
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const form = this.$copy(this.form)
                        form.serviceId = form.serviceIds[1] ? form.serviceIds[1] : form.serviceIds[0]
                        delete form.serviceIds
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            }
        },
        mounted() {
            this.loadData()
            vendorServiceList(this.companyId)
                .then(res => {
                    this.services = res.data.data
                    this.services.forEach(item => {
                        item.selected = !item.selected
                        if (item.subService) {
                            item.subService.forEach(subItem => {
                                subItem.selected = !subItem.selected
                            })
                        }
                    })
                })
        }
    }
</script>

<style scoped>

</style>
